module.exports = __webpack_public_path__ + "img/Spin-1s-200px.d4f046db.gif";